import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import MainLayout from '../components/layout/MainLayout';
import { webAppConfig } from '../config/appConfig';

export default function TermsPage() {
  return (
    <MainLayout
      className="landing-shell"
      header={(
        <Header
          className="landing-header"
          brandHref={webAppConfig.routes.home}
          logoSrc={webAppConfig.brand.logoPath}
          brandText={webAppConfig.brand.name}
          brandClassName="landing-brand"
          logoClassName="landing-brand-logo"
          brandTextClassName="landing-brand-name"
          variant="landing"
        />
      )}
      footer={(
        <Footer className="landing-footer" variant="landing" />
      )}
    >
      <main className="landing-section legal-page" aria-labelledby="terms-title">
        <div className="legal-hero">
          <span className="legal-kicker">Legal</span>
          <h1 id="terms-title">Terms of Service</h1>
          <p>
            These Terms explain the rules for using {webAppConfig.brand.name} as a marketplace platform. They are
            written to be practical, startup-ready, and clear about what the platform does—and does not—do.
          </p>
          <p><strong>Effective date:</strong> April 22, 2026</p>
        </div>

        <div className="legal-card">
          <h2>Acceptance of these terms</h2>
          <p>
            By accessing or using {webAppConfig.brand.name}, you agree to these Terms of Service and our{' '}
            <Link to={webAppConfig.routes.privacy}>Privacy Policy</Link>. If you do not agree, do not use the platform.
          </p>

          <h2>Marketplace-only role</h2>
          <p>
            {webAppConfig.brand.name} is a marketplace platform. We help users discover, evaluate, and connect with one
            another, but we are <strong>not</strong> an employer, staffing agency, recruiter of record, labor provider,
            payroll provider, or contracting party for user-to-user work arrangements.
          </p>

          <h2>Independent service providers</h2>
          <p>
            Service providers using the platform act as independent businesses or independent workers. They are not
            employees of {webAppConfig.brand.name}, and job posters are solely responsible for deciding whom to engage,
            how work is structured, and whether any separate written agreement is needed.
          </p>

          <h2>No guarantee of jobs or earnings</h2>
          <p>
            We do not guarantee job postings, project availability, worker availability, work outcomes, payments,
            placements, income, or earnings. Marketplace outcomes depend on user demand, timing, qualifications,
            responsiveness, and user conduct.
          </p>

          <h2>User responsibilities</h2>
          <ul className="legal-list">
            <li>Provide accurate, current, and lawful account and profile information</li>
            <li>Use the platform only for lawful marketplace activity</li>
            <li>Maintain the confidentiality of your credentials</li>
            <li>Communicate respectfully and avoid fraud, harassment, or misrepresentation</li>
            <li>Comply with tax, labor, licensing, insurance, and local legal obligations that apply to you</li>
          </ul>

          <h2>User-to-user interactions</h2>
          <p>
            Users are solely responsible for their communications, agreements, negotiations, services, job posts,
            performance, disputes, and any offline interactions that result from using the platform. You should perform
            your own judgment and diligence before working with another user.
          </p>

          <h2>Liability limits</h2>
          <p>
            To the maximum extent permitted by law, {webAppConfig.brand.name} and its operators are not liable for user
            conduct, failed transactions, service quality, employment classification issues, injuries, losses,
            reputational harm, payment disputes, or damages arising from interactions between users. The platform is
            provided on an “as is” and “as available” basis without warranties of uninterrupted access or specific results.
          </p>

          <h2>Suspension and termination</h2>
          <p>
            We may suspend, restrict, or terminate access to the platform if we believe a user violates these terms,
            presents a security or fraud risk, infringes rights, or creates legal or operational risk for the platform.
          </p>

          <h2>Changes to the service or terms</h2>
          <p>
            We may update these Terms as the product, business, or legal requirements evolve. Continued use of the
            platform after updates means you accept the revised Terms.
          </p>

          <p className="legal-crosslink">
            Please also read our <Link to={webAppConfig.routes.privacy}>Privacy Policy</Link>.
          </p>
        </div>
      </main>
    </MainLayout>
  );
}
